<template>
  <div class="grid-container" :style="gridStyle">
    <div
      v-for="n in 9"
      :key="n"
      class="grid-item"
      :class="{ center: n === 5 }"
      @click="$emit('item-click', n)"
    >
      <slot
        :name="
          [
            'itemA',
            'top',
            'itemB',
            'left',
            'center',
            'right',
            'itemC',
            'bottom',
            'itemD',
          ][n - 1]
        "
      >
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "stepItem",
  props: {
    outerWidth: {
      type: Number,
      default: 220,
      validator: (value) => value > 0,
    },
    outerHeight: {
      type: Number,
      default: 280,
      validator: (value) => value > 0,
    },
    centerWidth: {
      type: Number,
      default: 160,
      validator: (value) => value > 0,
    },
    centerHeight: {
      type: Number,
      default: 220,
      validator: (value) => value > 0,
    },
    gap: {
      type: Number,
      default: 0,
    },
    borderColor: {
      type: String,
      default: "rgba(255, 255, 255, 0.7)",
    },
  },
  emits: ["item-click"],
  computed: {
    // 计算左右两侧的宽度
    sideWidth() {
      return (this.outerWidth - this.centerWidth - this.gap * 2) / 2;
    },
    // 计算上下两侧的高度
    sideHeight() {
      return (this.outerHeight - this.centerHeight - this.gap * 2) / 2;
    },
    // 生成网格容器样式
    gridStyle() {
      return {
        width: `${this.outerWidth}px`,
        height: `${this.outerHeight}px`,
        gridTemplateColumns: `${this.sideWidth}px ${this.centerWidth}px ${this.sideWidth}px`,
        gridTemplateRows: `${this.sideHeight}px ${this.centerHeight}px ${this.sideHeight}px`,
        gap: `${this.gap}px`,
        borderColor: this.borderColor,
      };
    },
  },
  watch: {
    // 验证props的合理性
    centerWidth(newVal) {
      if (newVal >= this.outerWidth - this.gap * 2) {
        console.warn("中心宽度不能大于或等于外层宽度（减去间隙后）");
      }
    },
    centerHeight(newVal) {
      if (newVal >= this.outerHeight - this.gap * 2) {
        console.warn("中心高度不能大于或等于外层高度（减去间隙后）");
      }
    },
  },
};
</script>

<style scoped>
.grid-container {
  display: grid;
  /* border: 2px solid; */
  border-radius: 5px;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); */
  overflow: hidden;
}

.grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
}

/* 四角格子 */
/* .grid-item:nth-child(1),
.grid-item:nth-child(3),
.grid-item:nth-child(7),
.grid-item:nth-child(9) {
  background-color: #ff9a9e;
} */

/* 上下中间格子 */
/* .grid-item:nth-child(2),
.grid-item:nth-child(8) {
  background-color: #fad0c4;
} */

/* 左右中间格子 */
/* .grid-item:nth-child(4),
.grid-item:nth-child(6) {
  background-color: #fbc2eb;
} */

/* 中心格子 */
/* .grid-item.center {
  background: linear-gradient(45deg, #ff758c 0%, #ff7eb3 100%);
  color: white;
} */

/* .grid-item:hover {
  opacity: 0.9;
  transform: scale(1.02);
  z-index: 2;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
} */
</style>